import { css } from "styled-components"
import { colors } from "../../helpers/colors"
import { BreakPoints, media } from "../../helpers/rwd"

export const SectionWrapperStyles = css`
  background: ${colors.purpleMain};
`
export const BackgroundWrapperStyles = css``
export const BackgroundStyles = css`
  border: none;
  &:not(:first-child) {
    border-left: 0;
  }

  ${media.max(BreakPoints.tablet)} {
    background-size: 100%;
    background-position: center top;
  }

  ${media.max(BreakPoints.phone)} {
    background-size: 100%;
    background-position: top;
    width: 94%;
    &:hover{
      background-size: auto 301px;
    }
  }
`
export const ContentWrapperStyles = css`
  ${media.max(BreakPoints.smallDesktop)} {
    max-width: none;
    margin: 0 auto;
    width: 100%;
  }
  ${media.max(BreakPoints.tablet)} {
    margin-top: 250px;
    min-height: auto;
  }
`
export const ContentStyles = css``
export const ContentDescriptionStyles = css``
export const ContentButtonsStyles = css``
